// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"217d6d26","453":"bea66239"}[chunkId] + ".chunk.js";
};